import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2345a67a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#faad14","text-align":"center","background":"#fffbe6","line-height":"2.5","margin":"0 40px","font-size":"14px"} }, " 此列表仅显示已分配业务员的客户信息 ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "客户名称", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "渠道", -1))
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "业务负责人", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "客户标签查找", -1))
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "活跃度", -1))
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"35px"} }, null, -1))
const _hoisted_11 = { style: {"padding":"0 40px"} }
const _hoisted_12 = { class: "serialNumber" }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { style: {"align-items":"center"} }
const _hoisted_21 = {
  key: 0,
  style: {"color":"#e2e2e2","margin":"0 3px"}
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["title"]
const _hoisted_24 = { style: {"margin":"0 10px"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 10px"} }, "/", -1))
const _hoisted_26 = { style: {"color":"#008bcf","margin":"0 10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DecorateModalTitle = _resolveComponent("DecorateModalTitle")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_Screen = _resolveComponent("Screen")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "modal_task_target",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
    width: "1100px",
    onOk: _ctx.ok,
    okText: "提交",
    maskClosable: false,
    centered: "",
    confirmLoading: _ctx.confirmLoading,
    okButtonProps: {
      disabled: _ctx.selectedRowKeys.length === 0,
    }
  }, {
    title: _withCtx(() => [
      _createVNode(_component_DecorateModalTitle, { modalTitle: "客户列表" })
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_Screen, {
        onSearch: _ctx.search,
        formState: _ctx.formState,
        "onUpdate:formState": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState) = $event)),
        keepFormState: _ctx.keepFormState
      }, {
        "1": _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_a_input, {
            class: "input",
            value: _ctx.formState.keyword,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.keyword) = $event)),
            placeholder: "请输入关键字查找...",
            onKeyup: _withKeys(_ctx.search, ["enter"]),
            allowClear: ""
          }, null, 8, ["value", "onKeyup"])
        ]),
        "2": _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_a_select, {
            placeholder: "请选择...",
            style: {"width":"100%"},
            value: _ctx.formState.channelCode,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.channelCode) = $event)),
            optionFilterProp: "label"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelOption, (el, i) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: i,
                  value: el.channelCode
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      title: el.channelName
                    }, _toDisplayString(el.channelName), 9, _hoisted_4)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        "4": _withCtx(() => [
          _hoisted_5,
          _createVNode(_component_a_input, {
            class: "input",
            value: _ctx.formState.person,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.person) = $event)),
            placeholder: "请输入...",
            onKeyup: _withKeys(_ctx.search, ["enter"]),
            allowClear: ""
          }, null, 8, ["value", "onKeyup"])
        ]),
        "5": _withCtx(() => [
          _hoisted_6,
          _createVNode(_component_a_select, {
            placeholder: "请选择...",
            style: {"width":"100%"},
            value: _ctx.formState.cusLabId,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.cusLabId) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cusLabIdOption, (el, i) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: i,
                  value: el.customerLabelCode
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      title: el.customerLabelName
                    }, _toDisplayString(el.customerLabelName), 9, _hoisted_7)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        "3": _withCtx(() => [
          _hoisted_8,
          _createVNode(_component_a_select, {
            placeholder: "请选择...",
            style: {"width":"100%"},
            value: _ctx.formState.activity,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.activity) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityOption, (el, i) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: i,
                  value: el.code
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      title: el.name
                    }, _toDisplayString(el.name), 9, _hoisted_9)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        "6": _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onSearch", "formState", "keepFormState"]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_a_table, {
          style: { minHeight: '380px' },
          rowKey: "terminalCode",
          columns: _ctx.columns,
          "data-source": _ctx.dataAll,
          pagination: false,
          scroll: _ctx.scroll,
          loading: _ctx.loading,
          size: "small",
          "row-selection": {
          selectedRowKeys: _ctx.selectedRowKeys,
          onChange: _ctx.onSelectChange,
          columnWidth: 26,
          onSelect: _ctx.onSelect,
          hideDefaultSelections: true,
          onSelectAll: _ctx.onSelectAll,
        }
        }, {
          serialNumber: _withCtx(({ index }) => [
            _createElementVNode("span", _hoisted_12, _toDisplayString(index + 1), 1)
          ]),
          terminalName: _withCtx(({ record }) => [
            _createElementVNode("div", {
              class: "over_ellipsis",
              title: record.terminalName
            }, _toDisplayString(record.terminalName), 9, _hoisted_13),
            _createElementVNode("div", {
              class: "over_ellipsis",
              title: record.terminalCode
            }, _toDisplayString(record.terminalCode), 9, _hoisted_14)
          ]),
          channelName: _withCtx(({ record }) => [
            _createElementVNode("span", {
              title: record.channelName
            }, _toDisplayString(record.channelName || "--"), 9, _hoisted_15)
          ]),
          activity: _withCtx(({ record }) => [
            _createElementVNode("span", {
              title: record.activity
            }, _toDisplayString(record.activity || "--"), 9, _hoisted_16)
          ]),
          person: _withCtx(({ record }) => [
            _createElementVNode("span", {
              title: 
              record.person && record.person.map((el) => el.name).join(' ')
            
            }, _toDisplayString(record.person && record.person.map((el) => el.name).join(" ")), 9, _hoisted_17)
          ]),
          cusLabels: _withCtx(({ record }) => [
            _createElementVNode("div", {
              title: 
              record.cusLabels ? record.cusLabels.replace(',', ' | ') : ''
            ,
              class: "over_ellipsis"
            }, [
              (record.cusLabels)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.cusLabels.split(','), (el, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          index
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "|"))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(el), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, "--"))
            ], 8, _hoisted_18)
          ]),
          address: _withCtx(({ record }) => [
            _createElementVNode("div", {
              class: "over_ellipsis",
              title: record.address
            }, _toDisplayString(record.address), 9, _hoisted_23)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "scroll", "loading", "row-selection"]),
        _createVNode(_component_Pagination, {
          total: _ctx.total,
          onChangePagination: _ctx.changePagination,
          cache: false,
          ref: "Pagination"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createTextVNode(" 共"),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.total), 1),
              _createTextVNode("条数据 "),
              _hoisted_25,
              _createTextVNode("已选择 "),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.selectedRowKeys.length), 1),
              _createTextVNode(" 条 ")
            ])
          ]),
          _: 1
        }, 8, ["total", "onChangePagination"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onOk", "confirmLoading", "okButtonProps"]))
}